import React from 'react';
import { avatarColorFor } from '../../lib/avatarColor';

interface Props {
  userId: string;
  name: string;
  isDark: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLS: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'w-5 h-5 text-[10px]',
  md: 'w-7 h-7 text-xs',
  lg: 'w-8 h-8 text-sm',
};

function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

/** Colored-initial avatar circle. Same color-hash as UserBadge, shared across Jobs + Requests chat. */
const Avatar: React.FC<Props> = ({ userId, name, isDark, size = 'sm', className }) => {
  const colors = avatarColorFor(userId, isDark);
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold flex-shrink-0 select-none ${SIZE_CLS[size]} ${className ?? ''}`}
      style={{ backgroundColor: colors.bg, color: colors.text }}
      title={name}
    >
      {initialsFor(name)}
    </span>
  );
};

export default Avatar;
